import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';

type DeleteModalProps = {
  title: string;
  description: string;
  highlightedText?: string;
  isOpen: boolean;
  isLoading?: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onDelete: () => void;
  onClose: () => void;
};

export const DeleteModal = ({
  title,
  description,
  isOpen,
  size = 'xl',
  isLoading = false,
  highlightedText,
  onDelete,
  onClose,
}: DeleteModalProps) => {
  const renderDescription = () => {
    if (!highlightedText) {
      return description;
    }

    const parts = description.split(highlightedText);

    return (
      <span>
        {parts.map((part, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={index}>
            {part}
            {index < parts.length - 1 && <span className="text-l-sb">{highlightedText}</span>}
          </span>
        ))}
      </span>
    );
  };

  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      hideCloseButton
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>{renderDescription()}</ModalBody>
            <ModalFooter>
              <Button className="w-full shrink" size="md" variant="outline" onClick={handleClose}>
                Discard
              </Button>
              <Button
                className="w-full shrink"
                size="md"
                color="default"
                variant="solid"
                onClick={onDelete}
                isDisabled={isLoading}
              >
                {isLoading ? 'Deleting...' : 'Delete'}
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
